import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 17,
  height: 16,
  viewboxWidth: 17,
  viewboxHeight: 16,
};

const SMSIconFilled = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.165.67H15.5a1.333 1.333 0 0 1 1.333 1.333v9a1.334 1.334 0 0 1-1.334 1.333h-6.48l-4.16 2.88a.666.666 0 0 1-.666.047.666.666 0 0 1-.36-.594v-2.333H2.165a1.333 1.333 0 0 1-1.333-1.3V2.003A1.333 1.333 0 0 1 2.165.669Zm2.667 5h8a.667.667 0 1 0 0-1.334h-8a.667.667 0 1 0 0 1.334Zm8 3h-8a.667.667 0 0 1 0-1.334h8a.667.667 0 1 1 0 1.334Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};

export default SMSIconFilled;
